"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55890,12274],{

/***/ 289924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);



const CustomLink = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].a(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLink, {
    href: link,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;




/***/ }),

/***/ 955006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(289924);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203494);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ isMobile, theme }) => `
  display: flex;
  padding: ${theme == null ? void 0 : theme.spacing.s16} 0;
  align-items: ${!isMobile ? "flex-end" : "center"};
  column-gap: ${theme == null ? void 0 : theme.spacing.s4};
  white-space: nowrap;
  overflow: hidden;
  ${!isMobile ? `.breadcrumb-item:last-child div {
            white-space: normal
        }` : `
        overflow-x: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`);
const Breadcrumbs = (_a) => {
  var _b = _a, {
    breadcrumbs = [],
    isMobile
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "isMobile"
  ]);
  if (!breadcrumbs.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isMobile
  }), breadcrumbs.map((item, index) => {
    const isLast = index === breadcrumbs.length - 1 || item.isLast;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbItem */ .g, __spreadValues({
      key: index
    }, item)), !isLast && !!item.name && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RightOutlined */ .g, {
      color: "placeholder",
      size: 16,
      style: { textAlign: "right", overflow: "visible" }
    }));
  }));
};




/***/ }),

/***/ 816519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Glide; }
/* harmony export */ });
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(490400);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(593859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Glide = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_a, ref) => {
  var _b = _a, {
    className,
    children,
    onSlideChange,
    style,
    showControl = true,
    showBullet = false,
    trackingArrowRight,
    trackingArrowLeft,
    customStyleLeftArrow,
    customStyleRightArrow,
    displayNewLayout
  } = _b, glideOpts = __objRest(_b, [
    "className",
    "children",
    "onSlideChange",
    "style",
    "showControl",
    "showBullet",
    "trackingArrowRight",
    "trackingArrowLeft",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "displayNewLayout"
  ]);
  const newRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const childRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
  const chooseRef = ref || newRef;
  const opts = __spreadValues(__spreadValues({}, defaultGlideOptions), glideOpts);
  if (children.length === 1) {
    opts.autoplay = false;
    showBullet = false;
    showControl = false;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof chooseRef === "function" || !chooseRef.current)
      return;
    const controller = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(chooseRef.current, opts);
    let mounted;
    if (onSlideChange) {
      controller.on("move.after", () => {
        mounted && onSlideChange(mounted.index);
      });
    }
    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .scheduleTaskInIdleTime */ .D_)(() => {
      mounted = controller.mount();
      children.length === 1 && (mounted == null ? void 0 : mounted.disable());
      if (chooseRef.current) {
        chooseRef.current.glide = mounted;
      }
    }, 3e3);
    return () => mounted == null ? void 0 : mounted.destroy();
  }, [children.length]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, {
    ref: chooseRef,
    className: `${className || ""} glide`,
    style,
    displayNewLayout
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__slides"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      ref: (e) => childRefs.current[index] = e,
      key: child.key || index,
      className: "glide__slide",
      style: {
        height: "unset",
        marginRight: index < children.length - 1 ? ((_a2 = childRefs.current[index]) == null ? void 0 : _a2.style.marginRight) || 5 : 0,
        marginLeft: index > 0 ? ((_b2 = childRefs.current[index]) == null ? void 0 : _b2.style.marginLeft) || 5 : 0,
        width: ((_c = childRefs.current) == null ? void 0 : _c[0]) ? childRefs.current[0].style.width : `calc(100% / ${opts.perView} - 8px) `
      }
    }, child);
  }))), showControl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    "data-glide-el": "controls",
    className: "glide__arrows"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--left",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}<`,
    style: customStyleLeftArrow
  }, trackingArrowLeft)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--right",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}>`,
    style: customStyleRightArrow
  }, trackingArrowRight))), showBullet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__bullets glide__bullets--override",
    "data-glide-el": "controls[nav]"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (_, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
    className: "glide__bullet",
    key: index,
    "data-glide-dir": `=${index}`
  }))));
});
Glide.displayName = "Glide";
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => `
  &:hover {
    .glide__arrow--override {
      visibility: visible;
    }
  }

  .glide__track {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  .glide__slides {
    height: 100%;
  }
  .glide__arrow--override {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    transform: translateY(-50%);
    background-color: rgba(168, 168, 168, 0.46);
    visibility: hidden;
  }

  .glide__arrow--left {
    right: auto;
    left: 0;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  .glide__arrow--right {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  ${props.displayNewLayout ? `.glide__arrow--override {
    visibility: visible;
    width: 28px;
    height: 28px;
  }
  .horizontal-slider,
  .glide__track {
    margin: 0 auto;
    background-color: white;
  }
  .glide__slides {
    margin: 0 auto;
  }
  .glide__arrow--left {
    left: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }
  .glide__arrow--right {
    right: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }` : ``}
`);
const defaultGlideOptions = {
  type: "slider",
  startAt: 0,
  perView: 2.3,
  perSwipe: "",
  focusAt: 0,
  gap: 10,
  autoplay: false,
  hoverpause: true,
  keyboard: true,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  direction: "ltr",
  peek: 0,
  breakpoints: {},
  throttle: 25
};




/***/ }),

/***/ 991822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor() || "",
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 517293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ChevronForwardFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronForwardFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "polyline",
        attr: {
          points: "184 112 328 256 184 400",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "currentColor"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 848884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HomepageFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomepageFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.512 1.43055C11.7928 1.18982 12.2073 1.18982 12.4881 1.43055L21.4881 9.14455C21.7264 9.3488 21.8123 9.67984 21.7035 9.9742C21.5946 10.2686 21.3139 10.464 21 10.464H20.75V19.18C20.75 20.1852 19.9665 21 19 21H15V16.1776C15 15.6001 14.7542 15.0462 14.3166 14.6378C13.879 14.2294 13.2856 14 12.6667 14H11.3333C10.7144 14 10.121 14.2294 9.6834 14.6378C9.24583 15.0462 9 15.6001 9 16.1776V21H5C4.0335 21 3.25 20.1852 3.25 19.18V10.464H3.00004C2.68618 10.464 2.40551 10.2686 2.29662 9.9742C2.18773 9.67984 2.27365 9.3488 2.51195 9.14455L11.512 1.43055Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 842918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29921);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(917709);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RightOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(27477), __webpack_require__.e(64871), __webpack_require__.e(80710)]).then(__webpack_require__.bind(__webpack_require__, 564871)).then((mod) => mod.RightOutlined));
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className,
  style
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor,
    style
  }, link ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color || ""
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightOutlined, {
    color: link.color
  })))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title));
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 784241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a;
  return `
    width: ${100 / ((_a = props.slidesPerView) != null ? _a : 1)}%;
    flex-shrink: 0;
    margin-right: 8px;
  `;
});




/***/ }),

/***/ 414562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77322);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(784241);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(922859);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products = [],
    productsPerRow,
    className,
    regionName,
    hideCtaButton,
    border,
    customStyleLeftArrow,
    customStyleRightArrow,
    desktopProps
  } = _b, props = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton",
    "border",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "desktopProps"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const trackViewProductListData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return products.map((product) => {
      var _a2, _b2;
      return {
        sku: product.sku || "",
        category: ((_b2 = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.name) || ""
      };
    });
  }, [products]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (trackViewProductListData.length > 0) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackViewProductList */ .u)(trackViewProductListData);
    }
  }, [JSON.stringify(trackViewProductListData)]);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
      key: product.sku,
      border: !!border
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail",
        index: index + 1,
        payload: product.bestComboDiscount && Number(product.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      addToCart: hideCtaButton ? void 0 : product.addToCart
    }))))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A, __spreadValues(__spreadProps(__spreadValues({
    perView: productsPerRow || 5,
    perSwipe: "|",
    className,
    customStyleLeftArrow,
    customStyleRightArrow
  }, props), {
    showControl: products.length > (productsPerRow || 5),
    swipeThreshold: products.length > (productsPerRow || 5),
    dragThreshold: products.length > (productsPerRow || 5)
  }), desktopProps), products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    key: item.sku,
    border: !!border
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail",
      index: index + 1,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }),
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"])(Card)(({ theme, border }) => __spreadValues({
  height: "100%"
}, border ? {
  border: "1px solid",
  borderColor: theme.colors.divider,
  borderRadius: theme.spacing.s8,
  overflow: "hidden"
} : {}));




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            })
        ]
    });
};


/***/ }),

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 192719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ RelateVideosAndPosts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(517293);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  line-height: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 540px;\n  background-color: black;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const YoutubeFrame = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 42609).then(__webpack_require__.bind(__webpack_require__, 742609)).then((mod)=>mod.YoutubeFrame), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(742609)
            ]
    }
});
const MAX_ITEMS_WITH_TWO_BLOCKS = 3;
const StyledH3 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].h3(_templateObject());
const IFramePopupWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject1());
const StyledCustomLink = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x)(_templateObject2());
const RelatedBlock = (props)=>{
    const { 0: youtubeLink , 1: setYoutubeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const { title , type , seeMoreUrl , items  } = props;
    const renderItem = (url, description)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
            gap: "s8",
            align: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .LazyImage */ .w, {
                    height: "56px",
                    width: "100px",
                    borderRadius: 6,
                    contain: true,
                    src: url,
                    imageWidth: 200
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                    width: "calc(100% - 100px - 16px)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                        line: 3,
                        level: 1,
                        children: description
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                padding: "s16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledH3, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                        gap: "s12",
                        direction: "column",
                        marginTop: "s12",
                        children: items.map((item, index)=>{
                            const { url , thumbnailUrl , description  } = item;
                            return type === "post" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCustomLink, {
                                href: url,
                                target: "_blank",
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                                onClick: ()=>setYoutubeLink(url),
                                style: {
                                    cursor: "pointer",
                                    width: "100%"
                                },
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url));
                        })
                    }),
                    !!seeMoreUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
                        href: seeMoreUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                            paddingTop: "s16",
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                                variant: "link",
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Xem th\xeam nội dung"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .ChevronForwardFilled */ .O, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Modal */ .u, {
                visible: !!youtubeLink,
                width: "960px",
                onClose: ()=>setYoutubeLink(""),
                showCloseIcon: false,
                footer: false,
                contentStyle: {
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IFramePopupWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeFrame, {
                        youtubeLink: youtubeLink
                    })
                })
            })
        ]
    });
};
const RelateVideosAndPosts = (props)=>{
    var ref, ref1, ref2, ref3;
    const { relatedPosts , relatedVideos  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref = relatedVideos.urls) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: relatedVideos.urls.map((video, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "VideoObject",
                                name: video.name,
                                description: video.description,
                                thumbnailUrl: video.thumbnailUrl,
                                uploadDate: typeof video.uploadDate === "number" ? new Date(video.uploadDate * 1000).toISOString() : "",
                                embedUrl: video.url
                            })
                        }
                    }, "".concat(index).concat(video.url));
                })
            }),
            !!(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref1 = relatedPosts.urls) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                marginTop: "s12",
                marginBottom: !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref2 = relatedVideos.urls) === null || ref2 === void 0 ? void 0 : ref2.length) ? "s0" : "s12",
                backgroundColor: "white",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedPosts.title || "",
                    type: "post",
                    seeMoreUrl: relatedPosts.seeMoreUrl,
                    items: relatedPosts.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , description  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: description || ""
                        };
                    })
                })
            }),
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref3 = relatedVideos.urls) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                margin: [
                    "s12",
                    "s0"
                ],
                backgroundColor: "white",
                border: "s8",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedVideos.title || "",
                    type: "video",
                    seeMoreUrl: relatedVideos.seeMoreUrl,
                    items: relatedVideos.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , name  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: name || ""
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 124177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ INLINE_BANNER_CLASSNAME; }
/* harmony export */ });
var INLINE_BANNER_CLASSNAME;
(function(INLINE_BANNER_CLASSNAME) {
    INLINE_BANNER_CLASSNAME["INLINE_HOME_TOP"] = "INLINE-HOME-TOP";
    INLINE_BANNER_CLASSNAME["INLINE_HOME_BODY"] = "INLINE-HOME-BODY";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_RELATEDPROMO"] = "INLINE-PDP-RELATEDPROMO";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_SERVICE"] = "INLINE-PDP-SERVICE";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_DESK"] = "INLINE-PDP-PREVIEW-DESK";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_MOBILE"] = "INLINE-PDP-PREVIEW-MOBILE";
    INLINE_BANNER_CLASSNAME["INLINE_SEARCH"] = "INLINE-SEARCH";
    INLINE_BANNER_CLASSNAME["INLINE_CATEGORY"] = "INLINE-CATEGORY";
    INLINE_BANNER_CLASSNAME["INLINE_BRAND"] = "INLINE-BRAND";
    INLINE_BANNER_CLASSNAME["INLINE_SELLER"] = "INLINE-SELLER";
    INLINE_BANNER_CLASSNAME["INLINE_CART"] = "INLINE-CART";
    INLINE_BANNER_CLASSNAME["INLINE_CHECKOUT"] = "INLINE-CHECKOUT";
})(INLINE_BANNER_CLASSNAME || (INLINE_BANNER_CLASSNAME = {}));


/***/ }),

/***/ 534924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ProductDetailProvider; },
  "W": function() { return /* binding */ useProductDetailState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(423942);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(77829);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/HomepageFilled.es.js
var HomepageFilled_es = __webpack_require__(848884);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/payment/dist/types.es.js
var types_es = __webpack_require__(710957);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ./helpers/products.ts
var products = __webpack_require__(646130);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./contexts/ToastContext.tsx
var ToastContext = __webpack_require__(508285);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
;// CONCATENATED MODULE: ./hooks/useCalculatePrice.ts
/* eslint-disable react-hooks/exhaustive-deps */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const useCalculatePrice = (sku, defaultValue, productAvailable, selectPromotionId, isReturnVariants)=>{
    const { cartServiceV2  } = (0,ServiceContext/* useServices */.Su)();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const toast = (0,ToastContext/* useToast */.p)(isMobile);
    const { 0: payloadAddToCart , 1: setPayloadAddToCart  } = (0,react.useState)({
        sku,
        quantity: 1,
        isPrimary: undefined
    });
    const { 0: calculatePrice , 1: setCalculatePrice  } = (0,react.useState)(defaultValue);
    const { 0: isLoading , 1: setLoading  } = (0,react.useState)(false);
    const { quantity  } = payloadAddToCart;
    // hotfix for missing token when get price and promotion
    const { user  } = (0,context_es/* useAuth */.aC)();
    const { data: dataCalculatePrice , isValidating  } = (0,index_esm/* default */.ZP)(productAvailable ? [
        "cart_service/get_price",
        sku,
        quantity,
        selectPromotionId,
        user === null || user === void 0 ? void 0 : user.id,
        isReturnVariants, 
    ] : null, async (_, sku, quantity)=>{
        return cartServiceV2.getPriceAndPromotion(sku, _objectSpreadProps(_objectSpread({
            quantity
        }, !!selectPromotionId && !Number.isNaN(Number(selectPromotionId)) ? {
            selectedPromotionId: Number(selectPromotionId)
        } : {}), {
            isReturnVariants
        }));
    }, {
        revalidateOnFocus: false,
        fallback: _objectSpread({}, defaultValue)
    });
    const selectedPromotion = (0,react.useMemo)(()=>{
        try {
            const promotions = calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.promotions.map((p)=>p.promotions).reduce((a, b)=>[
                    ...a,
                    ...b
                ], []);
            return promotions === null || promotions === void 0 ? void 0 : promotions.find((p)=>p.isSelectable && p.isSelected);
        } catch (e) {
            return null;
        }
    }, [
        JSON.stringify(calculatePrice)
    ]);
    (0,react.useEffect)(()=>{
        if (!productAvailable) {
            setCalculatePrice(defaultValue);
        }
        if (!!dataCalculatePrice && !isValidating) {
            setCalculatePrice(dataCalculatePrice);
        }
    }, [
        JSON.stringify(dataCalculatePrice),
        isValidating,
        productAvailable,
        JSON.stringify(defaultValue), 
    ]);
    const selectPromotion = async (promotion)=>{
        try {
            setLoading(true);
            const newCalculate = await cartServiceV2.calculatePrice({
                sku: payloadAddToCart.sku,
                selectPromotionId: promotion === null || promotion === void 0 ? void 0 : promotion.promotionId,
                quantity: payloadAddToCart.quantity
            });
            setCalculatePrice(newCalculate);
            if (promotion === undefined) {
                var ref;
                (ref = toast.success) === null || ref === void 0 ? void 0 : ref.call(toast, {
                    title: "",
                    message: "",
                    [isMobile ? "message" : "title"]: (0,i18n.t)("Bỏ \xe1p dụng khuyến m\xe3i th\xe0nh c\xf4ng")
                });
            } else {
                var ref1;
                (ref1 = toast.success) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                    title: "",
                    message: "",
                    [isMobile ? "message" : "title"]: (0,i18n.t)("\xc1p dụng khuyến m\xe3i th\xe0nh c\xf4ng")
                });
            }
        } catch (err) {
            var ref2;
            index_es/* logger.error */.k.error(err);
            (ref2 = toast.error) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                title: "",
                message: "",
                [isMobile ? "message" : "title"]: (0,i18n.t)("C\xf3 lỗi xảy ra")
            });
        } finally{
            setLoading(false);
        }
    };
    return {
        price: _objectSpread({
            finalPrice: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.price
        }, calculatePrice),
        promotionBlocks: (calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.promotions) || [],
        setPayloadAddToCart,
        selectPromotion,
        payloadAddToCart,
        promotionLoading: isValidating,
        priceLoading: isValidating,
        selectPromotionLoading: isLoading,
        selectedPromotion,
        applicableInstallmentMethods: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.applicableInstallmentMethods,
        variants: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.variants
    };
};

// EXTERNAL MODULE: ./hooks/useDiscovery.tsx + 1 modules
var useDiscovery = __webpack_require__(88837);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 2 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(725530);
// EXTERNAL MODULE: ./services/consumer.ts
var consumer = __webpack_require__(667913);
;// CONCATENATED MODULE: ./hooks/useProductRating.ts
function useProductRating_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useProductRating_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useProductRating_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useProductRating_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useProductRating_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useProductRating_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const DEFAULT_GET_REVIEWS_PAGE_SIZE = 5;
const useProductRatingList = (product)=>{
    var ref, ref1;
    const { 0: filterParams , 1: setFilterParams  } = (0,react.useState)();
    const { 0: page , 1: setPage  } = (0,react.useState)(1);
    const { 0: reviews , 1: setReviews  } = (0,react.useState)([]);
    const getKey = ()=>{
        var ref, ref1;
        // have no productId -> stop fetching
        if (!(product === null || product === void 0 ? void 0 : (ref = product.productGroup) === null || ref === void 0 ? void 0 : ref.id)) return null;
        return [
            "/product-reviews/".concat(product === null || product === void 0 ? void 0 : (ref1 = product.productGroup) === null || ref1 === void 0 ? void 0 : ref1.id),
            page,
            filterParams === null || filterParams === void 0 ? void 0 : filterParams.rating,
            filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasImage,
            filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasVideo, 
        ];
    };
    const { data , isValidating , mutate: refreshReviewList ,  } = (0,index_esm/* default */.ZP)(getKey, async ()=>{
        try {
            var ref;
            if (!(product === null || product === void 0 ? void 0 : (ref = product.productGroup) === null || ref === void 0 ? void 0 : ref.id)) return undefined;
            const res = await (0,consumer/* getProductReviews */.mk)(product.productGroup.id, useProductRating_objectSpreadProps(useProductRating_objectSpread({}, filterParams), {
                page,
                pageSize: DEFAULT_GET_REVIEWS_PAGE_SIZE
            }));
            return res;
        } catch (error) {
            index_es/* logger.error */.k.error("Error occur when getProductReviews: ".concat(error));
            return undefined;
        }
    }, {
        onSuccess: (data)=>{
            var ref;
            const newReviews = (data === null || data === void 0 ? void 0 : (ref = data.pagination) === null || ref === void 0 ? void 0 : ref.page) === 1 ? data.reviews : [
                ...reviews,
                ...(data === null || data === void 0 ? void 0 : data.reviews) || []
            ];
            setReviews(newReviews);
        },
        revalidateOnFocus: false
    });
    const { ratingCounts , averageRating , totalReviews  } = data || {};
    return {
        data,
        reviews,
        ratingCounts,
        averageRating,
        totalReviews,
        filterParams,
        setFilterParams,
        loadMore: ()=>setPage((prev)=>prev + 1),
        hasMore: reviews.length < ((data === null || data === void 0 ? void 0 : (ref = data.pagination) === null || ref === void 0 ? void 0 : ref.total) || 0),
        noFilter: !filterParams || Object.values(filterParams).every((val)=>!val),
        numberOfReviewsRemaining: ((data === null || data === void 0 ? void 0 : (ref1 = data.pagination) === null || ref1 === void 0 ? void 0 : ref1.total) || 0) - reviews.length,
        setPage,
        isValidating,
        refreshReviewList
    };
};

;// CONCATENATED MODULE: ./hooks/useDetailPage.tsx
function useDetailPage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDetailPage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDetailPage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useDetailPage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useDetailPage_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useDetailPage_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















const useDetailPage = (serverProduct)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const { epicOmni976 , isMobile , epicOmni1459 , merchantInstallmentMethodCode , epicEcom495 , passSkuToReturnSimilarProducts , displayNewLayoutForProductDetailSGC ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { paymentBffService  } = (0,ServiceContext/* useServices */.Su)();
    const { 0: sku , 1: setSku  } = (0,react.useState)(serverProduct === null || serverProduct === void 0 ? void 0 : (ref = serverProduct.product) === null || ref === void 0 ? void 0 : (ref1 = ref.productInfo) === null || ref1 === void 0 ? void 0 : ref1.sku);
    const { 0: showPopupCheckAge , 1: setShowModalCheckAge  } = (0,react.useState)();
    const { 0: isUserUnder18 , 1: setIsUserUnder18  } = (0,react.useState)();
    const { 0: showWarningPromotionWithInstallment , 1: setShowWarningPromotionWithInstallment  } = (0,react.useState)(false);
    const { 0: minAmountByMonth , 1: setMinAmountByMonth  } = (0,react.useState)();
    const { 0: isReturnVariants , 1: setIsReturnVariants  } = (0,react.useState)(false);
    const { convertProduct  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)({
        handleUnder18: ()=>setShowModalCheckAge(true)
    });
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const setShowPopupCheckAge = (value)=>{
        setShowModalCheckAge(value);
        if (!value) {
            setIsUserUnder18(false);
            (0,confirm18YearsOld/* markUserIsOver18 */.P1)();
        }
    };
    const router = (0,next_router.useRouter)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const { result , mutate: mutateProduct , isLoading ,  } = (0,useDiscovery/* useDiscoveryProduct */.uD)(sku || router.query.sku, router.query.productId, {
        revalidateIfStale: true,
        fallbackData: serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.product
    });
    (0,react.useEffect)(()=>{
        // use useEffect instead of swr onSuccess
        // since the later does not get called consistently
        if (!isLoading && (result === null || result === void 0 ? void 0 : result.product) && router.query.sku != sku) {
            const { sku: newSku , canonical  } = result.product.productInfo;
            const queryParams = (0,dist_index_es.cleanObject)({
                sku: newSku,
                productId: router.query.productId
            });
            router.replace({
                pathname: !router.query.productId ? "/products/[sku]" : "/products/detail/[productId]",
                query: queryParams
            }, {
                pathname: "/".concat(canonical),
                query: (0,products/* isVariantUrlGrouped */.X)(canonical) ? {
                    sku: newSku
                } : {}
            }, {
                //In new detailPage SGC new layout, when replace router with new sku, always rerender the page.
                shallow: !displayNewLayoutForProductDetailSGC
            });
        }
    }, [
        isLoading,
        result === null || result === void 0 ? void 0 : (ref2 = result.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.productInfo) === null || ref3 === void 0 ? void 0 : ref3.sku,
        displayNewLayoutForProductDetailSGC, 
    ]);
    const { flattenItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    // state to check if a product variant is being fetched
    // to be replaced with a global loader
    const product = (0,discovery/* convertProductDetail */.NP)(result.product);
    const defaultPrice = !(0,helpers/* isServerless */.ep)() ? serverProduct.priceAndPromotions : convertDiscoveryPrice(product.price, ((ref4 = product.status) === null || ref4 === void 0 ? void 0 : ref4.sellable) ? serverProduct === null || serverProduct === void 0 ? void 0 : (ref5 = serverProduct.priceAndPromotions) === null || ref5 === void 0 ? void 0 : ref5.promotions : []);
    /**
   * product from server is product in HCM City
   * if user is in other city, we need revalidate price and promotions
   */ const { price , promotionBlocks , setPayloadAddToCart , selectPromotion , payloadAddToCart , promotionLoading , priceLoading , selectedPromotion , selectPromotionLoading , applicableInstallmentMethods , variants ,  } = useCalculatePrice(sku, defaultPrice, product === null || product === void 0 ? void 0 : (ref6 = product.status) === null || ref6 === void 0 ? void 0 : ref6.sellable, router.query.selectPromotionId || (0,helpers_es/* getParamsFromUrl */.FW)(router.asPath, "selectPromotionId") || "", isReturnVariants);
    const searchRelatedProductsParams = passSkuToReturnSimilarProducts ? {
        page: 1,
        pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
        filter: {
            skuToReturnSimilarProducts: sku
        }
    } : !!(product === null || product === void 0 ? void 0 : product.categories.length) ? {
        page: 1,
        pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
        filter: {
            excludedSkus: [
                product === null || product === void 0 ? void 0 : product.sku
            ],
            categoryIds: [
                product === null || product === void 0 ? void 0 : product.categories[(product === null || product === void 0 ? void 0 : product.categories.length) - 1].id
            ]
        }
    } : {};
    const { result: searchRelatedProductsResult  } = (0,useDiscovery/* useSearch */.Rx)(searchRelatedProductsParams);
    // fallback to serverProduct if not found
    const relatedProducts = ((ref7 = (searchRelatedProductsResult === null || searchRelatedProductsResult === void 0 ? void 0 : searchRelatedProductsResult.products) || []) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 ? searchRelatedProductsResult === null || searchRelatedProductsResult === void 0 ? void 0 : searchRelatedProductsResult.products : serverProduct.relatedProducts;
    // EPIC-315: effect replace images when user is under 18 years old
    const { images , actionReady  } = (0,react.useMemo)(()=>{
        return convertProduct(product);
    }, [
        product === null || product === void 0 ? void 0 : product.categories,
        isUserUnder18,
        authLoading
    ]);
    const productRatingData = useProductRatingList(useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, product), {
        images
    }));
    // backward compatibility for epic_ecom_315
    (0,react.useEffect)(()=>{
        if (flags.epic_ecom_315) return;
        if ((0,confirm18YearsOld/* needConfirm18YearsOld */.av)((product === null || product === void 0 ? void 0 : product.isAlcoholicCategory) || false)) {
            setShowPopupCheckAge(true);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.sku,
        product === null || product === void 0 ? void 0 : product.isAlcoholicCategory
    ]);
    const stockAvailable = (product === null || product === void 0 ? void 0 : product.needManageStock) ? (product === null || product === void 0 ? void 0 : product.totalAvailable) || 0 : 999;
    const onSelectVariant = async (variant)=>{
        // if other sku
        const newSku = variant.sku;
        if (newSku === router.query.sku && variant.quantity === payloadAddToCart.quantity) return;
        setPayloadAddToCart((prev)=>{
            return useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, prev), {
                // note: this logic is little confusing.
                // for variants that have no overlapping attributes with current sku
                // Discovery productOptions is returning 0 quantity
                // client would display this variant as a blurred option.
                quantity: variant.quantity === 0 ? 1 : variant.quantity,
                sku: variant.sku
            });
        });
        if (newSku === router.query.sku) {
            var ref;
            await mutateProduct(useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, result.product), {
                productOptions: useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, product.productOptions), {
                    rows: (ref = product.productOptions) === null || ref === void 0 ? void 0 : ref.rows.map((row)=>useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, row), {
                            options: row.options.map((col)=>col.quantity === variant.quantity ? useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, col), {
                                    selected: true
                                }) : useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, col), {
                                    selected: false
                                }))
                        }))
                })
            }), {
                revalidate: false
            });
        } else {
            setSku(newSku);
        }
    };
    const isCanAddToCard = product && (product.isBundle || passQuantityCheck(product === null || product === void 0 ? void 0 : product.needManageStock, stockAvailable, (ref8 = (flattenItems || []).find((item)=>item.sku === product.sku)) === null || ref8 === void 0 ? void 0 : ref8.quantity));
    const isOutOfStock = (product === null || product === void 0 ? void 0 : product.totalAvailable) !== null && product.totalAvailable !== undefined && (product === null || product === void 0 ? void 0 : product.totalAvailable) <= 0;
    const showFlashSale = (0,react.useMemo)(()=>{
        if (!product) return false;
        if (!product.flashSale) return false;
        const { total , used  } = product.flashSale;
        const remain = Math.min(total - used, stockAvailable);
        return remain > 0;
    }, [
        product,
        stockAvailable
    ]);
    const breadcrumbs = (0,react.useMemo)(()=>{
        var ref;
        if (epicEcom495) {
            var ref1;
            const homeBreadcrumb = [
                {
                    link: "/",
                    name: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageFilled_es/* HomepageFilled */.f, {
                        size: 16,
                        color: "placeholder",
                        style: {
                            marginRight: "4px"
                        }
                    }),
                    isLast: true
                },
                {
                    link: "/",
                    name: (0,i18n.t)("Trang chủ")
                }, 
            ];
            const productName = (product === null || product === void 0 ? void 0 : product.displayName) || (product === null || product === void 0 ? void 0 : product.name) || "";
            const breadcrumbs = (product === null || product === void 0 ? void 0 : (ref1 = product.breadcrumbs) === null || ref1 === void 0 ? void 0 : ref1.length) ? [
                ...homeBreadcrumb,
                ...product.breadcrumbs
            ] : [
                ...homeBreadcrumb
            ];
            return [
                ...breadcrumbs,
                {
                    disabled: true,
                    link: "#",
                    name: productName
                }, 
            ];
        }
        if (!(serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.breadcrumbs) || (serverProduct === null || serverProduct === void 0 ? void 0 : (ref = serverProduct.breadcrumbs) === null || ref === void 0 ? void 0 : ref.length) === 0 || !epicOmni976) {
            return isMobile || epicOmni976 ? [] : [
                {
                    link: "/",
                    name: (0,i18n.t)("Trang chủ")
                },
                {
                    disabled: true,
                    link: "#",
                    name: (product === null || product === void 0 ? void 0 : product.displayName) || (product === null || product === void 0 ? void 0 : product.name) || ""
                }, 
            ];
        }
        return [
            {
                link: "/",
                name: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageFilled_es/* HomepageFilled */.f, {
                    size: 24,
                    color: "placeholder"
                })
            },
            ...serverProduct.breadcrumbs, 
        ];
    }, [
        epicOmni976,
        isMobile,
        epicEcom495
    ]);
    const isAllowInstallmentPayment = (0,react.useMemo)(()=>{
        var ref, ref1;
        return !!epicOmni1459 && ((ref = serverProduct.priceAndPromotions) === null || ref === void 0 ? void 0 : (ref1 = ref.availableInstallmentPaymentMethods) === null || ref1 === void 0 ? void 0 : ref1.includes(types_es/* PaymentMethodCode.VNPAY_INSTALLMENT_CREDIT */.K$.VNPAY_INSTALLMENT_CREDIT));
    }, [
        (ref9 = serverProduct.priceAndPromotions) === null || ref9 === void 0 ? void 0 : ref9.availableInstallmentPaymentMethods,
        epicOmni1459, 
    ]);
    const selectedPromotionsNotApplyWithInstallment = (0,react.useMemo)(()=>{
        return promotionBlocks.flatMap((promotionGroup)=>promotionGroup.promotions).filter((promotion)=>{
            var ref;
            return promotion.isSelected && !!((ref = promotion.highlightedDescriptions) === null || ref === void 0 ? void 0 : ref.length);
        });
    }, [
        promotionBlocks
    ]);
    const getMinAmountByMonth = (terms)=>{
        const periods = terms.flatMap((t)=>t.paymentMethods.flatMap((paymentMethod)=>paymentMethod.periods));
        let minAmount;
        if (periods.length) {
            minAmount = periods[0].amountByMonth;
            for(let i = 0; i < periods.length; i++){
                if (periods[i].amountByMonth < minAmount) {
                    minAmount = periods[i].amountByMonth;
                }
            }
        }
        return minAmount;
    };
    const vnpayInstallmentCreditMethod = (0,react.useMemo)(()=>{
        return !!(applicableInstallmentMethods === null || applicableInstallmentMethods === void 0 ? void 0 : applicableInstallmentMethods.length) ? applicableInstallmentMethods.find((method)=>method.methodCode === types_es/* PaymentMethodCode.VNPAY_INSTALLMENT_CREDIT */.K$.VNPAY_INSTALLMENT_CREDIT) : undefined;
    }, [
        applicableInstallmentMethods
    ]);
    (0,react.useEffect)(()=>{
        const getInstallmentTerms = async (merchantMethodCode, amount)=>{
            try {
                const { terms  } = await paymentBffService.getInstallmentTerms(merchantMethodCode, amount);
                const minAmount = getMinAmountByMonth(terms);
                setMinAmountByMonth(minAmount);
            } catch (error) {
                index_es/* logger.error */.k.error("getInstallmentTerms error", error);
                window.track("GetInstallmentTermsEvent", "getInstallmentTermsError", error);
            }
        };
        // not call API when not allow purchase in installment (isAllowInstallmentPayment = false)
        if (isAllowInstallmentPayment && merchantInstallmentMethodCode && typeof (vnpayInstallmentCreditMethod === null || vnpayInstallmentCreditMethod === void 0 ? void 0 : vnpayInstallmentCreditMethod.installmentPrice) === "number") {
            getInstallmentTerms(merchantInstallmentMethodCode, vnpayInstallmentCreditMethod.installmentPrice);
        }
    }, [
        vnpayInstallmentCreditMethod === null || vnpayInstallmentCreditMethod === void 0 ? void 0 : vnpayInstallmentCreditMethod.installmentPrice,
        paymentBffService,
        merchantInstallmentMethodCode,
        isAllowInstallmentPayment, 
    ]);
    return {
        isLoading,
        product: useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, product), {
            images
        }),
        primitiveProduct: (result === null || result === void 0 ? void 0 : result.product) || serverProduct.product,
        frame: (0,products/* getFrame */.$)((product === null || product === void 0 ? void 0 : product.tags) || [], frames),
        onSelectVariant,
        stockAvailable,
        isOutOfStock,
        relatedProducts,
        isCanAddToCard,
        showFlashSale,
        setSelectedPromotion: selectPromotion,
        selectPromotionLoading,
        price,
        setPayloadAddToCart,
        payloadAddToCart,
        promotionBlocks,
        promotionLoading,
        priceLoading,
        selectedPromotion,
        showPopupCheckAge,
        setShowPopupCheckAge,
        actionReady,
        breadcrumbs: breadcrumbs || [],
        isAllowInstallmentPayment,
        showWarningPromotionWithInstallment,
        setShowWarningPromotionWithInstallment,
        selectedPromotionsNotApplyWithInstallment,
        minAmountByMonth,
        variants,
        setIsReturnVariants,
        productRatingData
    };
};
const passQuantityCheck = (needManageStock, totalAvailable, quantity)=>{
    if (needManageStock && quantity !== undefined && quantity >= totalAvailable) return false;
    return true;
};
const convertDiscoveryPrice = function(price) {
    let promotions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!price || !price.price || !price.sellPrice) return null;
    return {
        price: price.price,
        discountPercent: price.discount ? "-".concat(price.discount, "%") : undefined,
        displayRowTotal: (0,Currency_es/* formatCurrency */.xG)(price.price, {
            underline: true
        }),
        strikeThroughDisplayRowTotal: (0,Currency_es/* formatCurrency */.xG)(price.supplierRetailPrice || price.sellPrice, {
            underline: true
        }),
        promotions: promotions
    };
};

;// CONCATENATED MODULE: ./contexts/ProductDetailContext.tsx
function ProductDetailContext_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductDetailContext_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductDetailContext_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductDetailContext_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ProductDetailContext_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ProductDetailContext_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const initialState = {
    onSelectVariant: ()=>{},
    promotionBlocks: [],
    relatedProducts: [],
    showPopupCheckAge: false,
    setShowPopupCheckAge: ()=>{},
    selectPromotionLoading: false,
    showWarningPromotionWithInstallment: false,
    setShowWarningPromotionWithInstallment: ()=>{},
    selectedPromotionsNotApplyWithInstallment: [],
    productRatingData: {
        reviews: [],
        hasMore: false,
        setFilterParams: ()=>{},
        loadMore: ()=>{},
        noFilter: false,
        numberOfReviewsRemaining: 0,
        setPage: ()=>{},
        isValidating: false,
        refreshReviewList: ()=>{}
    }
};
const ProductDetailStateContext = /*#__PURE__*/ react.createContext(initialState);
const ProductDetailProvider = (param)=>{
    let { children , serverProduct , inlineBanners  } = param;
    const detailPage = useDetailPage(serverProduct);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailStateContext.Provider, {
            value: ProductDetailContext_objectSpreadProps(ProductDetailContext_objectSpread({}, detailPage), {
                inlineBanners
            }),
            children: children
        })
    });
};
function useProductDetailState() {
    const context = (0,react.useContext)(ProductDetailStateContext);
    if (!context) {
        throw new Error("useProductDetailState must be inside a ProductDetailStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 708648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ MetaData; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./components/JsonLd.tsx


const JsonLd = (param)=>/*#__PURE__*/ {
    let { data  } = param;
    return (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(data)
        }
    });
};

// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
;// CONCATENATED MODULE: ./modules/product-detail/shared/MetaData.tsx






const MetaData = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    const { product , primitiveProduct  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { baseDomain , canonicalDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    let canonical;
    if (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref = primitiveProduct.productInfo) === null || ref === void 0 ? void 0 : ref.canonical) {
        if (canonicalDomain) {
            canonical = "".concat(canonicalDomain, "/").concat(primitiveProduct.productInfo.canonical);
        } else if (baseDomain) {
            canonical = "".concat(baseDomain, "/").concat(primitiveProduct.productInfo.canonical);
        }
    }
    const data = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref1 = primitiveProduct.productInfo) === null || ref1 === void 0 ? void 0 : ref1.name,
        image: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref2 = primitiveProduct.productInfo) === null || ref2 === void 0 ? void 0 : ref2.imageUrl,
        brand: {
            "@type": "Brand",
            name: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref3 = primitiveProduct.productInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.brand) === null || ref4 === void 0 ? void 0 : ref4.name
        },
        offers: {
            "@type": "Offer",
            price: (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref5 = primitiveProduct.prices) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.latestPrice) || 0,
            url: "".concat(baseDomain, "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref7 = primitiveProduct.productInfo) === null || ref7 === void 0 ? void 0 : ref7.canonical),
            priceCurrency: "VND",
            itemCondition: "https://schema.org/NewCondition",
            availability: (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.totalAvailable) === null || !!(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.totalAvailable) ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        },
        url: "".concat(baseDomain, "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref8 = primitiveProduct.productInfo) === null || ref8 === void 0 ? void 0 : ref8.canonical),
        description: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref9 = primitiveProduct.productDetail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.seoInfo) === null || ref10 === void 0 ? void 0 : ref10.metaDescription,
        sku: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref11 = primitiveProduct.productInfo) === null || ref11 === void 0 ? void 0 : ref11.sku,
        category: (ref12 = primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.productInfo.categories) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.name,
        additionalProperty: product === null || product === void 0 ? void 0 : (ref14 = product.attributeGroups) === null || ref14 === void 0 ? void 0 : ref14.filter((att)=>!!att.value && att.parentId !== 0).map((att)=>({
                "@type": "PropertyValue",
                name: att.name,
                value: att.value
            }))
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd, {
                data: data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, {
                canonical: canonical,
                title: (product === null || product === void 0 ? void 0 : (ref15 = product.seoInfo) === null || ref15 === void 0 ? void 0 : ref15.metaTitle) || (product === null || product === void 0 ? void 0 : product.name),
                description: (product === null || product === void 0 ? void 0 : (ref16 = product.seoInfo) === null || ref16 === void 0 ? void 0 : ref16.metaDescription) || false,
                keywords: product === null || product === void 0 ? void 0 : (ref17 = product.seoInfo) === null || ref17 === void 0 ? void 0 : ref17.metaKeyword,
                image: product === null || product === void 0 ? void 0 : (ref18 = product.images) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.src
            })
        ]
    });
};


/***/ }),

/***/ 555082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ReviewSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ui_review__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(885541);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(423942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(842918);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  .title {\n    padding: 0 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ReviewSection = (param)=>{
    let { product , wrapperBorderRadius  } = param;
    var ref, ref1;
    const { colors , borderRadius  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)();
    const { tekReviewAppId  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const { user , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)();
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    if (!tekReviewAppId) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        wrapperBorderRadius: wrapperBorderRadius,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBlockHeader, {
                title: "Đ\xe1nh gi\xe1 sản phẩm",
                borderColor: "#ebeaea"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui_review__WEBPACK_IMPORTED_MODULE_1__/* .TekReview */ .O, {
                appId: tekReviewAppId,
                entity: {
                    key: product.sku,
                    imageUrl: ((ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                    title: product.name
                },
                theme: {
                    colors: {
                        primary: colors.primary,
                        primaryActive: colors.primary600,
                        primaryHover: colors.primary700
                    },
                    borderRadius: borderRadius.s
                },
                reviewer: user ? {
                    displayName: user.name,
                    avatarUrl: user.avatar,
                    email: user.email,
                    phoneNumber: user.telephone
                } : undefined,
                onRequestLogin: ()=>setShow(true)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Modal */ .u, {
                visible: show,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đăng nhập"),
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đăng nhập"),
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Hủy"),
                onOk: ()=>{
                    authService === null || authService === void 0 ? void 0 : authService.login(window.location.href);
                },
                onCancel: ()=>{
                    setShow(false);
                },
                footer: true,
                onBackDrop: ()=>setShow(false),
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Vui l\xf2ng đăng nhập để đ\xe1nh gi\xe1 sản phẩm.")
            })
        ]
    });
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div((param)=>{
    let { wrapperBorderRadius  } = param;
    return "\n  position: relative;\n  background-color: #fff;\n  margin-top: 8px;\n  margin-bottom: 0.5rem;\n  border-radius: ".concat(wrapperBorderRadius || "0px", ";\n");
});
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .BlockHeader */ .t)(_templateObject(), (props)=>props.borderColor);


/***/ }),

/***/ 667913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ sendOTPToEmail; },
/* harmony export */   "Jz": function() { return /* binding */ createStudentInfo; },
/* harmony export */   "aP": function() { return /* binding */ getCustomerProfile; },
/* harmony export */   "mk": function() { return /* binding */ getProductReviews; },
/* harmony export */   "nE": function() { return /* binding */ createProductReview; },
/* harmony export */   "qD": function() { return /* binding */ verifyOTP; }
/* harmony export */ });
/* harmony import */ var _teko_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(847143);
/* harmony import */ var _clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44844);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


const getProductReviews = async (productId, params)=>{
    const { data  } = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.get */ .hS.get("api/v1/products/".concat(productId, "/reviews"), {
        params: _objectSpread({}, params)
    });
    return data.data;
};
const createProductReview = async (productId, payload)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .E);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/products/".concat(productId, "/reviews"), payload);
    return res.data;
};
const getCustomerProfile = async (params)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .E);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.get */ .hS.get("api/v1/profiles", {
        params: _objectSpread({}, params)
    });
    return res.data;
};
const createStudentInfo = async (profileId, payload, language)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .E);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/profiles/".concat(profileId, "/student-info"), payload, {
        headers: {
            "Accept-Language": language || "*"
        }
    });
    return res.data;
};
const sendOTPToEmail = async (payload)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .E);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/profiles/otp/send-email", payload);
    return res.data;
};
const verifyOTP = async (payload)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .E);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/profiles/otp/verify-email", payload);
    return res.data;
};


/***/ }),

/***/ 710957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jg": function() { return /* binding */ PaymentBankCode; },
/* harmony export */   "K$": function() { return /* binding */ PaymentMethodCode; },
/* harmony export */   "Lt": function() { return /* binding */ PaymentMethodType; },
/* harmony export */   "Vc": function() { return /* binding */ PaymentCardType; },
/* harmony export */   "Wk": function() { return /* binding */ BankType; },
/* harmony export */   "fH": function() { return /* binding */ PaymentBffCardType; },
/* harmony export */   "kJ": function() { return /* binding */ PaymentMethodGroupCode; }
/* harmony export */ });
var PaymentMethodCode = /* @__PURE__ */ ((PaymentMethodCode2) => {
  PaymentMethodCode2["COD"] = "COD";
  PaymentMethodCode2["COD_OFFLINE"] = "COD_OFFLINE";
  PaymentMethodCode2["VNPAYQR"] = "VNPAYQR";
  PaymentMethodCode2["VNPAY_GATEWAY"] = "VNPAY_GATEWAY";
  PaymentMethodCode2["VNPAY_QRCODE"] = "VNPAY_QRCODE";
  PaymentMethodCode2["CTT"] = "CTT";
  PaymentMethodCode2["MOBILE_BANKING"] = "MOBILE_BANKING";
  PaymentMethodCode2["LOYALTY"] = "LOYALTY";
  PaymentMethodCode2["EVOUCHER"] = "Phi\u1EBFu mua h\xE0ng";
  PaymentMethodCode2["CASH"] = "CASH";
  PaymentMethodCode2["VNPAY_TOKEN"] = "VNPAY_TOKEN";
  PaymentMethodCode2["ALEPAY_INSTALLMENT_CREDIT"] = "ALEPAY_INSTALLMENT_CREDIT";
  PaymentMethodCode2["VNPAY_INSTALLMENT_CREDIT"] = "VNPAY_INSTALLMENT_CREDIT";
  PaymentMethodCode2["PAYBILL"] = "PAYBILL";
  PaymentMethodCode2["VNPAY_GATEWAY_QR"] = "VNPAY_GATEWAY_QR";
  PaymentMethodCode2["VNPAY_GATEWAY_MOBILE_BANKING"] = "VNPAY_GATEWAY_MOBILE_BANKING";
  PaymentMethodCode2["VNPAY_GATEWAY_ATM"] = "VNPAY_GATEWAY_ATM";
  PaymentMethodCode2["VNPAY_GATEWAY_INTERNATIONAL_CARD"] = "VNPAY_GATEWAY_INTERNATIONAL_CARD";
  PaymentMethodCode2["ZALOPAY_GATEWAY"] = "ZALOPAY_GATEWAY";
  PaymentMethodCode2["MOMO_AIO"] = "MOMO_AIO";
  return PaymentMethodCode2;
})(PaymentMethodCode || {});
var PaymentBankCode = /* @__PURE__ */ ((PaymentBankCode2) => {
  PaymentBankCode2["VNPAYQR"] = "VNPAYQR";
  return PaymentBankCode2;
})(PaymentBankCode || {});
var PaymentMethodGroupCode = /* @__PURE__ */ ((PaymentMethodGroupCode2) => {
  PaymentMethodGroupCode2["CREDIT"] = "CREDIT";
  PaymentMethodGroupCode2["INSTALLMENT"] = "INSTALLMENT";
  PaymentMethodGroupCode2["CARD"] = "CARD";
  PaymentMethodGroupCode2["OFFLINE"] = "OFFLINE";
  PaymentMethodGroupCode2["LOYALTY"] = "LOYALTY";
  PaymentMethodGroupCode2["QR"] = "QR";
  return PaymentMethodGroupCode2;
})(PaymentMethodGroupCode || {});
var PaymentCardType = /* @__PURE__ */ ((PaymentCardType2) => {
  PaymentCardType2[PaymentCardType2["REDIRECT_URL_THANH_TOAN"] = 1] = "REDIRECT_URL_THANH_TOAN";
  PaymentCardType2[PaymentCardType2["GEN_QR_CONG"] = 2] = "GEN_QR_CONG";
  return PaymentCardType2;
})(PaymentCardType || {});
var PaymentBffCardType = /* @__PURE__ */ ((PaymentBffCardType2) => {
  PaymentBffCardType2["URL_REDIRECT"] = "URL_REDIRECT";
  PaymentBffCardType2["QR_CONTENT"] = "QR_CONTENT";
  PaymentBffCardType2["URL_DEEPLINK"] = "URL_DEEPLINK";
  return PaymentBffCardType2;
})(PaymentBffCardType || {});
var BankType = /* @__PURE__ */ ((BankType2) => {
  BankType2["BANK"] = "bank";
  BankType2["WALLET"] = "wallet";
  BankType2["INTERNATIONAL_CARD"] = "international_card";
  return BankType2;
})(BankType || {});
var PaymentMethodType = /* @__PURE__ */ ((PaymentMethodType2) => {
  PaymentMethodType2["MOBILE_BANKING"] = "MOBILE_BANKING";
  PaymentMethodType2["ATM"] = "ATM";
  PaymentMethodType2["VISA"] = "VISA";
  return PaymentMethodType2;
})(PaymentMethodType || {});




/***/ }),

/***/ 77322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ trackViewProductDetail; },
/* harmony export */   "u": function() { return /* binding */ trackViewProductList; }
/* harmony export */ });
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(437618);


const trackViewProductDetail = (product) => {
  var _a, _b;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewDetail",
    ecommerce: {
      detail: {
        products: [product]
      }
    }
  });
  if (!!window.fbq && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
    const value = typeof product.price === "number" ? product.price : parseFloat(product.price) || 0;
    (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackMetaPixelViewContent */ .SI)({
      content_ids: [product.sku],
      content_category: product.category || "",
      content_name: product.name || "",
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value
    });
  }
};
const trackViewProductList = (products) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewListing",
    ecommerce: {
      impressions: products
    }
  });
};




/***/ })

}]);